@if (showMessage) {
    <div class="note success">
        <i class="sports-check"></i>
        <span [innerHTML]="messageContent"></span>
    </div>
}
